<template>
  <div class="membership-payment app-page">
    <div class="payment-container">
      <div v-if="loading" class="loading">
        <div class="spinner"></div>
        <p>加载中...</p>
      </div>

      <div v-if="error" class="error-message">{{ error }}</div>

      <div v-if="orderInfo && !loading" class="payment-content">
        <div class="payment-layout">
          <div class="order-summary">
            <div class="summary-header">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
              <h2>订单信息</h2>
            </div>
            <div class="order-details">
              <div class="detail-row">
                <span class="label">订单编号</span>
                <span class="value">{{ orderInfo.orderNo }}</span>
              </div>
              <div class="detail-row">
                <span class="label">会员类型</span>
                <span class="value tag-value">{{ orderInfo.membershipTypeName }}</span>
              </div>
              <div class="detail-row">
                <span class="label">创建时间</span>
                <span class="value">{{ formatDate(orderInfo.createTime) }}</span>
              </div>
              <div class="detail-row">
                <span class="label">订单状态</span>
                <span class="value"><span class="status-tag">{{ orderInfo.statusName }}</span></span>
              </div>
              <div class="detail-divider"></div>
              <div class="detail-row total">
                <span class="label">支付金额</span>
                <span class="value price">¥{{ orderInfo.amount }}</span>
              </div>
            </div>
          </div>

          <div class="payment-methods">
            <div class="summary-header">
              <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
              <h2>选择支付方式</h2>
            </div>
            <div class="method-options">
              <div class="method-item" :class="{ selected: selectedMethod === 'alipay' }" @click="selectedMethod = 'alipay'">
                <div class="method-left">
                  <div class="method-icon alipay">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M21.422 15.358c-3.22-1.386-6.847-2.408-10.276-3.127 1.68-3.54 3.413-7.215 4.697-11.09H9.673c-1.32 3.305-3.067 7.21-4.98 10.495 1.636.585 3.203 1.264 4.71 2.016 1.83-3.285 3.597-6.58 4.75-9.23.524 1.578.916 3.214 1.354 4.79.868 2.888 1.85 5.627 3.035 8.105-.023.004-.046.004-.07.005a2.766 2.766 0 00-.304-.05c-1.607-.21-3.03-.737-4.48-1.895-2.08 2.183-4.494 4.09-7.344 5.243-1.84.745-4.427 1.19-6.375.225-.942-.467-1.425-1.305-1.274-2.522.093-.755.48-1.394.973-1.855 2.448-2.287 5.532-3.42 8.817-4.215-1.444-1.523-2.838-3.134-3.97-4.937-1.263-2.015-1.968-4.644-1.445-7.602.144-.812.58-1.365 1.386-1.568.413-.105.94-.025 1.358.088 5.11 1.206 7.296 4.637 8.698 9.088.096.305.073.242.227.068.26-.29.628-.363 1.01-.534 1.338-.597 2.722-1.11 4.083-1.63.34-.13.688-.232 1.028-.366v-2.9c0-1.927 0-2.89-.652-3.615-.653-.724-1.68-.724-3.738-.724H6.256c-2.058 0-3.087 0-3.738.724-.652.724-.652 1.688-.652 3.615v7.77c0 1.927 0 2.89.652 3.615.651.724 1.68.724 3.738.724h11.488c2.058 0 3.087 0 3.738-.724.328-.364.484-.897.566-1.677.03-.284.036-.586.046-.912.037-1.217-.622-1.57-1.422-1.958z"/></svg>
                  </div>
                  <div class="method-info">
                    <h3>支付宝</h3>
                    <p>推荐使用支付宝扫码支付</p>
                  </div>
                </div>
                <div class="method-selector" :class="{ selected: selectedMethod === 'alipay' }">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
              </div>

              <div class="method-item" :class="{ selected: selectedMethod === 'wechat' }" @click="selectedMethod = 'wechat'">
                <div class="method-left">
                  <div class="method-icon wechat">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor"><path d="M8.691 2.188C3.891 2.188 0 5.476 0 9.53c0 2.212 1.17 4.203 3.002 5.55a.59.59 0 01.213.665l-.39 1.48c-.019.07-.048.141-.048.213 0 .163.13.295.29.295a.326.326 0 00.167-.054l1.903-1.114a.864.864 0 01.717-.098 10.16 10.16 0 002.837.403c.276 0 .543-.027.811-.05-.857-2.578.157-4.972 1.932-6.446 1.703-1.415 3.882-1.98 5.853-1.838-.576-3.583-4.196-6.348-8.596-6.348zM5.785 5.991c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178A1.17 1.17 0 014.623 7.17c0-.651.52-1.18 1.162-1.18zm5.813 0c.642 0 1.162.529 1.162 1.18a1.17 1.17 0 01-1.162 1.178 1.17 1.17 0 01-1.162-1.178c0-.651.52-1.18 1.162-1.18zm5.34 2.867c-1.797-.052-3.746.512-5.28 1.786-1.72 1.428-2.687 3.72-1.78 6.22.942 2.453 3.666 4.229 6.884 4.229.826 0 1.622-.12 2.361-.336a.722.722 0 01.598.082l1.584.926a.272.272 0 00.14.045c.134 0 .24-.11.24-.245 0-.06-.024-.12-.04-.178l-.325-1.233a.492.492 0 01.178-.553C23.028 18.333 24 16.592 24 14.628c0-3.299-3.063-5.77-7.062-5.77zm-2.18 2.453c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982zm4.36 0c.535 0 .969.44.969.982a.976.976 0 01-.969.983.976.976 0 01-.969-.983c0-.542.434-.982.97-.982z"/></svg>
                  </div>
                  <div class="method-info">
                    <h3>微信支付</h3>
                    <p>推荐使用微信扫码支付</p>
                  </div>
                </div>
                <div class="method-selector" :class="{ selected: selectedMethod === 'wechat' }">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
              </div>

              <div class="method-item" :class="{ selected: selectedMethod === 'card' }" @click="selectedMethod = 'card'">
                <div class="method-left">
                  <div class="method-icon card">
                    <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="4" width="22" height="16" rx="2" ry="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
                  </div>
                  <div class="method-info">
                    <h3>银行卡支付</h3>
                    <p>支持各大银行储蓄卡和信用卡</p>
                  </div>
                </div>
                <div class="method-selector" :class="{ selected: selectedMethod === 'card' }">
                  <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="action-bar">
          <button class="cancel-btn" @click="$router.go(-1)">取消支付</button>
          <button
            class="pay-btn"
            @click="handlePayment"
            :disabled="!selectedMethod || orderInfo.status !== 0"
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
            确认支付 ¥{{ orderInfo.amount }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import membershipApi from '@/api/membership';
import { useRoute, useRouter } from 'vue-router';
import { ElMessage, ElMessageBox } from 'element-plus';

const route = useRoute();
const router = useRouter();
const orderInfo = ref(null);
const loading = ref(true);
const error = ref('');
const orderNo = ref(route.query.orderNo);
const selectedMethod = ref('alipay');

const fetchOrderInfo = async () => {
  if (!orderNo.value) {
    error.value = '订单编号不存在';
    loading.value = false;
    return;
  }

  try {
    // 实际项目中应该有获取订单详情的API
    // 这里我们通过获取用户订单列表来找到对应的订单
    const userId = localStorage.getItem('userId');
    if (!userId) {
      ElMessage.error('请先登录');
      router.push('/login');
      return;
    }

    const res = await membershipApi.getMembershipOrders(Number(userId));
    if (res.data.code == 200) {
      const orders = res.data.data;
      const foundOrder = orders.find(order => order.orderNo === orderNo.value);

      if (foundOrder) {
        orderInfo.value = foundOrder;

        // 如果订单已支付，提示并跳转
        if (foundOrder.status === 1) {
          ElMessageBox.alert('该订单已支付成功', '提示', {
            confirmButtonText: '查看会员详情',
            callback: () => {
              router.push('/membership/detail');
            }
          });
        }
      } else {
        error.value = '未找到该订单信息';
      }
    } else {
      error.value = res.data.msg || '获取订单信息失败';
    }
  } catch (err) {
    error.value = err.response?.data?.msg || '获取订单信息失败';
  } finally {
    loading.value = false;
  }
};

const handlePayment = async () => {
  if (!orderNo.value) return;

  try {
    loading.value = true;
    const res = await membershipApi.payMembershipOrder(orderNo.value);

    if (res.data.code == 200 && res.data.data) {
      ElMessageBox.alert('支付成功，您已成为会员！', '成功', {
        confirmButtonText: '查看会员详情',
        callback: () => {
          router.push('/membership/detail');
        }
      });
    } else {
      ElMessage.error(res.data.msg || '支付失败，请重试');
    }
  } catch (err) {
    ElMessage.error(err.response?.data?.msg || '支付过程中发生错误');
  } finally {
    loading.value = false;
  }
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleString('zh-CN', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  });
};

onMounted(() => {
  fetchOrderInfo();
});
</script>

<style scoped>

.payment-container {
  width: 100%;
}

.loading {
  text-align: center;
  padding: 60px 0;
}

.loading p {
  margin-top: 16px;
  color: var(--app-text-secondary);
}

.spinner {
  width: 40px;
  height: 40px;
  margin: 0 auto;
  border: 3px solid var(--app-border-light);
  border-top-color: var(--app-color-primary);
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-message {
  color: #e74c3c;
  background: rgba(231, 76, 60, 0.08);
  padding: 14px 20px;
  border-radius: var(--app-radius-md);
  text-align: center;
  margin-bottom: 1rem;
  border: 1px solid rgba(231, 76, 60, 0.15);
}

.payment-layout {
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  gap: 24px;
}

.order-summary,
.payment-methods {
  background: var(--app-bg-card);
  border-radius: var(--app-radius-xl);
  padding: 24px;
  box-shadow: var(--app-shadow-card);
  border: 1px solid var(--app-border-subtle);
}

.summary-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--app-border-light);
}

.summary-header svg {
  color: var(--app-color-primary);
}

.summary-header h2 {
  font-size: 1.125rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0;
}

.order-details {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.9375rem;
}

.detail-row .label {
  color: var(--app-text-secondary);
  font-weight: 500;
}

.detail-row .value {
  color: var(--app-text-primary);
  font-weight: 500;
  text-align: right;
}

.detail-row .value.tag-value {
  color: var(--app-color-primary);
}

.detail-row .value.price {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--app-color-primary);
}

.detail-divider {
  height: 1px;
  background: var(--app-border-light);
  margin: 4px 0;
}

.status-tag {
  display: inline-block;
  padding: 2px 10px;
  border-radius: var(--app-radius-full);
  background: var(--app-color-primary-soft);
  color: var(--app-color-primary);
  font-size: 0.8125rem;
}

.detail-row.total {
  padding-top: 4px;
}

/* Payment methods */
.method-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.method-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--app-bg-soft);
  border: 2px solid var(--app-border-light);
  border-radius: var(--app-radius-lg);
  padding: 16px 18px;
  cursor: pointer;
  transition: all 0.25s ease;
}

.method-item:hover {
  border-color: var(--app-color-primary-light);
  background: var(--app-color-primary-muted);
}

.method-item.selected {
  border-color: var(--app-color-primary);
  background: var(--app-color-primary-soft);
}

.method-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.method-icon {
  width: 44px;
  height: 44px;
  border-radius: var(--app-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
}

.method-icon.alipay {
  background: linear-gradient(135deg, #1677ff, #4096ff);
}

.method-icon.wechat {
  background: linear-gradient(135deg, #07c160, #39d17a);
}

.method-icon.card {
  background: linear-gradient(135deg, #faad14, #ffc53d);
}

.method-info h3 {
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--app-text-primary);
  margin: 0 0 2px;
}

.method-info p {
  font-size: 0.8125rem;
  color: var(--app-text-secondary);
  margin: 0;
}

.method-selector {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  border: 2px solid var(--app-border-light);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
  flex-shrink: 0;
}

.method-selector.selected {
  background: var(--app-color-primary);
  border-color: var(--app-color-primary);
  color: #fff;
}

.method-selector svg {
  display: none;
}

.method-selector.selected svg {
  display: block;
}

/* Action bar */
.action-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 16px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid var(--app-border-light);
}

.cancel-btn {
  padding: 12px 28px;
  background: var(--app-bg-elevated);
  color: var(--app-text-secondary);
  border: 1px solid var(--app-border-light);
  border-radius: var(--app-radius-lg);
  font-size: 0.9375rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.25s ease;
  font-family: inherit;
}

.cancel-btn:hover {
  border-color: var(--app-color-primary);
  color: var(--app-color-primary);
}

.pay-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 32px;
  background: var(--app-gradient-primary);
  color: #fff;
  border: none;
  border-radius: var(--app-radius-lg);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 4px 15px rgba(255, 126, 126, 0.35);
  font-family: inherit;
}

.pay-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 126, 126, 0.45);
}

.pay-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}

@media (max-width: 768px) {
  .payment-layout {
    grid-template-columns: 1fr;
  }

  .action-bar {
    flex-direction: column;
  }

  .cancel-btn,
  .pay-btn {
    width: 100%;
    justify-content: center;
  }
}
</style>
